import { render, staticRenderFns } from "./TeamMemberDetails.vue?vue&type=template&id=1ce91cbb&"
import script from "./TeamMemberDetails.vue?vue&type=script&lang=js&"
export * from "./TeamMemberDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports